import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    standalone: true,
    imports: [CommonModule, MatIconModule],    
  selector: 'app-usp-section',
  templateUrl: './usp-section.component.html',
  styleUrls: ['./usp-section.component.scss']
})
export class UspSectionComponent {
  @Input() imageUrl: string = 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/67e6798bbffa03a7b6f38220_Foto%2008.04.24%2C%2010%2006%2016.jpg';
  @Input() quote: string = '„Erfolg ist die beste Rache für all jene, die an dir gezweifelt haben.“';
  @Input() cards: Array<{ icon: string; title: string; description: string }> = [
    {
      icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab6109d78abf2a6d1fa9_icon_benefits.svg',
      title: 'Schneller Lernfortschritt',
      description: 'Erhalte Trading-Konzepte, die du schrittweise in deiner eigenen Praxis anwenden und auswerten kannst.'
    },
    {
      icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab61c3efb376f91384b7_icon_benefits-1.svg',
      title: 'Schritt-für-Schritt-Wissensaufbau',
      description: 'Bestimme selbst, wann und wie du lernst: Wähle die Module, die zu deiner Situation passen, wiederhole einzelne Lektionen und baue dir Schritt für Schritt dein eigenes Fachwissen auf.'
    },
    {
        icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab61fc1964800599a8fb_icon_benefits-2.svg',
        title:'Starke Community',
        description:'Suchst du nach einem Netzwerk von Gleichgesinnten? Werde Teil einer unterstützenden Community und tausche dich mit erfolgreichen Tradern aus.'
    },
    {
        icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab6153fa46d74607efff_icon_benefits-3.svg',
        title: 'KI-basierte Analyse-Methoden',
        description: 'Lerne, wie du eigenverantwortlich KI-Bots auf Drittplattformen konfigurierst und ihre Auswirkungen auf deine Ergebnisse analysierst. '
    }

    
    
  ];
} 